<template>
    <div class="submain">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="服务消息" name="servicemsg">
                <div class="msgbox">
                    <div class="" v-if="servicemsgList.length > 0">
                        <div class="item" v-for="(item, index) in servicemsgList" :key="index">
                            <div class="flexbox top">
                                <h3>您有一张优惠券到账了</h3>
                                <div class="flexbox right">
                                    <span class="reddot"></span>
                                    <span class="date">2017-12-26 21:10:30</span>
                                </div>
                            </div>
                            <div class="flexbox con">
                                <p>您昨天累计收到1张价值10.0元的优惠券，赶紧快去看看吧！</p>
                                <div class="right">
                                    查看详情 >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nodata" v-else>
                        <img src="../../../assets/img/nodata.svg">
                        <p>未收到任何服务消息</p>
                    </div>
                </div>
                <div class="pages" v-if="servicemsgList.length > 0">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="系统消息" name="systemmsg">
                <div class="msgbox">
                    <div class="" v-if="systemmsgList.length > 0">
                        <div class="item" v-for="(item, index) in systemmsgList" :key="index">
                            <div class="flexbox top">
                                <h3>系统消息</h3>
                                <div class="flexbox right">
                                    <span class="reddot"></span>
                                    <span class="date">2017-12-26 21:10:30</span>
                                </div>
                            </div>
                            <div class="flexbox con">
                                <p>您昨天累计收到1张价值10.0元的优惠券，赶紧快去看看吧！</p>
                                <div class="right">
                                    查看详情 >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nodata" v-else>
                        <img src="../../../assets/img/nodata.svg">
                        <p>未收到任何系统消息</p>
                    </div>
                </div>
                <div class="pages" v-if="systemmsgList.length > 0">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { ref } from 'vue'

    export default {
        name: 'Notification',
        setup() {
            let activeName = ref('servicemsg')
            let handleClick = (tab, event) => {
   
            }
            let servicemsgList = ref([1,2,3,4,5,6,7,8,9,10])
            let systemmsgList = ref([])
            // 翻页
            let currentPage = ref(1)
            let handleCurrentChange = () => {}
            return {
                activeName,
                handleClick,
                currentPage,
                handleCurrentChange,
                servicemsgList,
                systemmsgList,
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        padding-bottom: 20px;
        background: #fff;
        .msgbox {
            padding: 5px;
            .item {
                border: 1px solid rgba(237, 237, 237, 1);
                margin-bottom: 10px;
                .top {
                    background: rgba(249, 249, 249, 1);
                    padding: 15px;
                    justify-content: space-between;
                    h3 {
                        font-size: 16px;
                    }
                    .right {
                        .reddot {
                            display: block;
                            width: 10px;
                            height: 10px;
                            border-radius: 200px;
                            background: #f00;
                            margin-right: 15px;
                        }
                        .date {
                            color: #363636;
                        }
                    }
                }
                .con {
                    justify-content: space-between;
                    padding: 20px 15px;
                    p {
                        font-size: 12px;
                        color: #666;
                    }
                    .right {
                        font-size: 12px;
                        cursor: pointer;
                        &:hover {
                            color: rgb(244 ,36, 52);
                        }
                    }
                }
            }
            .nodata {
                text-align: center;
                padding: 150px 0;
                img {
                    width: 150px;
                }
                p {
                    font-size: 20px;
                    color: #999;
                    margin-top: 20px;
                }
            }
        }
        .pages {
            margin-top: 30px;
            ::v-deep(.el-input__inner) {
                height: 25px;
                width: 40px;
            }
            ::v-deep(.el-pagination.is-background .el-pager li:hover) {
                background: rgba(255, 0, 0, 1);
                color: #fff;
            }
        }
    }
</style>